<template>
  <div class="submission-image">
    <div class="submission-image__frame">
      <SubmissionLightboxClose @click="handleCloseClick" />
      <img :src="src" class="submission-image__image" />
    </div>
  </div>
</template>

<script>
import SubmissionLightboxClose from './../components/submission-lightbox-close';

export default {
  name: 'submission-image',
  components: {
    SubmissionLightboxClose
  },
  props: {
    src: { type: String, required: true },
    id: { type: String, required: true },
    lightbox: { type: Boolean, default: false }, // lightbox mode , full player,
    aspectRatio: { type: String, default: null }
  },
  methods: {
    handleCloseClick() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss">
.submission-image {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  &__frame {
    position: relative;
    border:
      $size-border-submissions-section-thumbnail-large
      solid
      $color-border-submissions-section-thumbnail-base;
    border-radius: $size-border-radius-submissions-section-thumbnail-large;
    overflow: hidden;
  }
  &__image {
    display: block;
    max-height: 100%;
    max-width: 100%;
  }
}
</style>
